import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ValuationPage } from '@/features/commercial/valuation-page';

const searchSchema = z.object({
  tab: z.enum(['lines', 'sheet', 'evidence', 'review']).optional().catch(undefined),
});

export const Route = createFileRoute(
  '/_app/projects/$projectId/commercial/valuations/$valuationId',
)({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId, valuationId } = Route.useParams();
  const search = Route.useSearch();
  return <ValuationPage projectId={projectId} valuationId={valuationId} tab={search.tab} />;
}
